/* eslint-disable no-restricted-syntax */
import store from "store";

export function setStorageItem(key, value) {
  store.set(key, value);
}

export function getStorageItem(key) {
  return store.get(key);
}

export function removeStorageItem(key) {
  store.remove(key);
}

export function clearAllStorage() {
  store.clearAll();
}

function getRelationshipKey(id, foreignCollection, foreignId) {
  return `${id}_${foreignCollection}_${foreignId}`;
}

function getRelationshipPrefix(id, foreignCollection) {
  return `${id}_${foreignCollection}`;
}

export function setRelatedStorageItem(id, foreignCollection, foreignId, value) {
  const key = getRelationshipKey(id, foreignCollection, foreignId);

  setStorageItem(key, value);
}

export function getRelatedStorageItem(id, foreignCollection, foreignId) {
  const key = getRelationshipKey(id, foreignCollection, foreignId);

  return getStorageItem(key);
}

export function removeRelatedStorageItem(id, foreignCollection, foreignId) {
  const key = getRelationshipKey(id, foreignCollection, foreignId);

  removeStorageItem(key);
}

export function getRelatedStorageItems(id, foreignCollection) {
  const prefix = getRelationshipPrefix(id, foreignCollection);
  let result = [];

  store.each((value, key) => {
    if (key.startsWith(prefix)) {
      result = [...result, value];
    }
  });

  return result;
}

export function clearRelatedStorageItems(id, foreignCollection) {
  const prefix = getRelationshipPrefix(id, foreignCollection);
  let keys = [];

  store.each((value, key) => {
    if (key.startsWith(prefix)) {
      keys = [...keys, key];
    }
  });

  for (const key of keys) {
    store.remove(key);
  }
}
